import script from "./detalhes-contato-reunioes.vue?vue&type=script&setup=true&lang=js"
export * from "./detalhes-contato-reunioes.vue?vue&type=script&setup=true&lang=js"

import "./detalhes-contato-reunioes.vue?vue&type=style&index=0&id=3bdbff92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bdbff92"]])

export default __exports__